import { render, staticRenderFns } from "./wechatuser-add-or-update.vue?vue&type=template&id=fc808804&"
import script from "./wechatuser-add-or-update.vue?vue&type=script&lang=js&"
export * from "./wechatuser-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports